import React, { useEffect } from "react";
import { endpoints } from "config";
import api from "api";
import { AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { WorkflowListData } from "./WorkflowConfigurations";
import { Spinner } from "components/Spinner/Spinner";

type WorkflowClonePlaceholderProps = {
  actionType: "create" | "edit" | "view";
  //   | "clone"
  selectedData: WorkflowListData[];
  onDone(): void;
  idFromRowOption: React.ReactText | null;
  onClose?: () => void;
};

const WorkflowClonePlaceholder: React.FC<WorkflowClonePlaceholderProps> = ({
  actionType,
  selectedData,
  onDone,
  idFromRowOption,
  onClose,
}) => {
  const cloneGateway = async (id: string) => {
    try {
      // Post with payload:
      const payload = {
        workflowsId: id,
      };
      const response = await api.post(
        endpoints.workflowConfiguration.clone,
        payload
      );

      // Post with query string parameters:
      // const response = await api.post(endpoints.gateways.clone, null, {
      //   params: {
      //     Id: parseInt(id),
      //   },
      // });

      if (response.status === 200 && response.data.status === `1`) {
        toast(
          <ToastMessage
            toastData={[
              { title: "Workflow cloned", text: "Workflow cloned successfuly" },
            ]}
            className="ToastSuccess"
          />,
          {
            ...toastConfig,
          }
        );
      } else {
        toast(
          <ToastMessage
            toastData={[
              {
                title: "Workflow clone error",
                text: "Failed to clone Workflow",
              },
            ]}
            className="ToastError"
          />,
          {
            ...toastConfig,
          }
        );
      }
    } catch (error) {
      toast(
        <ToastMessage
          toastData={[
            { title: "Workflow clone error", text: "Failed to clone Workflow" },
          ]}
          className="ToastError"
        />,
        {
          ...toastConfig,
        }
      );
    }

    onDone();
  };

  useEffect(() => {
    if (selectedData && selectedData[0] && selectedData[0].workflows__ID) {
      cloneGateway(String(selectedData[0].workflows__ID));
    } else if (idFromRowOption) {
      cloneGateway(`${idFromRowOption}`);
    }
  }, [selectedData, idFromRowOption]);
  return (
    <div className="WorkflowClonePlaceholder">
      <Spinner />
    </div>
  );
};

export default WorkflowClonePlaceholder;
